export default [
    {
        path: "config-settings",
        name: "addconfigsettings",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/setting/AddConfigSetting.vue"
            ),
        meta: {
            title: `Settings`,
        },
    },
    {
        path: "updateadminprofile",
        name: "adminprofile",
        component: () =>
            import(
            /* webpackChunkName: "profile" */ "../pages/setting/AdminProfileView.vue"
            ),
        meta: {
            title: `Settings`,
        },
    },
    {
        path: "panel-settings",
        name: "addpanelsettings",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/setting/AddPanelSetting.vue"
            ),
        meta: {
            title: `Settings`,
        },
    }
];
